import { GET_CHAT_LIST, SET_UNREAD_COUNT, UPDATE_CHAT_LAST_MESSAGE, UPDATE_STATIC_MESSAGE } from "../actions/types";

const initialState = {
  channelList: [],
  staticMessage: [],
  unreadCount: 0,
};
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {

    case GET_CHAT_LIST:
      return {
        ...state,
        channelList: payload,
      };

    case UPDATE_CHAT_LAST_MESSAGE:
      return {
        ...state,
        channelList: state.channelList.map(c =>
          c.chat._id === payload.chatId
            ? { ...c, lastMessage: payload.lastMessage }
            : c
        ),
        // setChats(prev =>
        //   prev.map(c =>
        //     c.chat._id === msg.chat ? { ...c, lastMessage: msg } : c
        //   )
        // );
      };

    case UPDATE_STATIC_MESSAGE:
      return {
        ...state,
        staticMessage: payload
      }
    case SET_UNREAD_COUNT:
      return {
        ...state,
        unreadCount: payload
      };
    default:
      return state;
  }
}
